import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const thorTemperatureChartStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            minHeight: "400px",
            maxHeight: "400px",
            marginBottom: "20px",
        },
        main: {
            padding: "10px 50px 30px 50px",
        },
        loadingIndicator: {
            width: 200,
            paddingTop: 30,
        },
        resetBtn: {
            float: "right",
            border: "1px solid #270ADC",
        },
        button: {
            borderRadius: "4px",
            padding: "3px 10px 3px 10px",
            marginTop: "5px",
        },
        selected: {
            backgroundColor: "#270ADC",
            color: "white",
            border: "1px solid #270ADC",
            "&:hover": {
                backgroundColor: "#270ADC",
            },
        },
        unSelected: {
            border: "1px solid rgba(0, 0, 0, 0.23)",
            backgroundColor: "white",
            color: "#270ADC",
            "&:hover": {
                backgroundColor: "white",
            },
        },
        devicesInfoRow: {
            marginTop: "70px",
        },
        icon: {
            display: "flex",
        },
    })
);
